// RelationshipHistory. Mirrors data-component="relationship-history"
// from the approved HTML. Dated events for current and former
// connections on this horse.
//
// TODO(runtime): hydrate from services/relationships.history(horseId)
// once the HTTP endpoint lands.
import type { ReactNode } from 'react';
import { HORSE_PORTRAIT_PLACEHOLDER } from '../../../data/mockData.js';
import type { RelationshipHistoryEvent } from '../mockData.js';
import type { RelationshipChange } from '../reviewState.js';

export interface RelationshipHistoryProps {
  events: RelationshipHistoryEvent[];
  retainedLabel: string;
  explainer: string;
  portraitUrl?: string;
  changes?: RelationshipChange[];
  horseNames?: Record<string, string>;
}

export function RelationshipHistory({
  events,
  retainedLabel,
  explainer,
  portraitUrl,
  changes = [],
  horseNames = {},
}: RelationshipHistoryProps): ReactNode {
  const fields = { type: 'Relationship type', organization: 'Organization', contact: 'Contact', specialty: 'Role', location: 'Location',
    startDate: 'Effective date', endedDate: 'End date', endReason: 'End reason', notes: 'Notes', status: 'Status', linkedHorseId: 'Linked horse', verification: 'Verification' };
  const display = (key: string, value: string | undefined) => key === 'linkedHorseId' ? horseNames[value || ''] || 'Horse not recorded' : value || 'Not recorded';
  return (
    <section className="card" data-component="relationship-history">
      <div className="section-heading">
        <h3>Relationship history</h3>
        <span>Keep the context</span>
      </div>
      <div className="history-visual-row">
        {portraitUrl !== '' && <img
          src={portraitUrl ?? HORSE_PORTRAIT_PLACEHOLDER}
          alt=""
        />}
        <div className="history-events">
          {changes.slice().reverse().map(event => <article className="relationship-history-change" key={event.id}>
            <strong>{event.kind === 'added' ? 'Relationship added' : event.kind === 'ended' ? 'Connection ended' : 'Relationship updated'}</strong>
            <small>{event.actor} · {new Date(event.recordedAt).toLocaleString('en-US')}</small>
            {(Object.keys(fields) as Array<keyof typeof fields>).filter(key => (event.before?.[key] || '') !== (event.after[key] || '')).map(key => <p key={key}>
              <b>{fields[key]}</b>: {display(key, event.before?.[key])} → {display(key, event.after[key])}
            </p>)}
          </article>)}
          {events.map((event) => (
            <div key={event.date + event.title}>
              <b>{event.date}</b>
              <span>{event.title}</span>
              <small>{event.detail}</small>
            </div>
          ))}
        </div>
      </div>
      <div className="history-footer">
        <strong>{retainedLabel}</strong>
        <span>{explainer}</span>
      </div>
    </section>
  );
}
